<template>
  <section>

    <b-row>
      <b-col md="12">
        <h2>Aceptación de solicitudes</h2>
      </b-col>
    </b-row>

    <div class="mt-4">

      <!-- Modal aceptar denegar -->
      <b-modal v-model="modalAutoriza" size="lg" no-close-on-backdrop>

        <b-col v-if="!cargandoRegistrosTotales">

          <p class="my-4">
            Se autorizará/denegará la solicitud para {{seleccionados.length }} registros seleccionados.
            Desea continuar con el proceso de autorización/denegación ?
          </p>

          <div class="mt-4" v-if=" insertRegistros.estado != null && !insertRegistros.estado">
            <!-- <b-alert class="mb-2" variant="danger" show>Error de carga</b-alert> -->
            <p>
              Se encontraron los siguientes errores
            </p>
          </div>

          <div class="mt-2" v-if=" insertRegistros.estado != null && !insertRegistros.estado && !( insertRegistros.alertas != null && insertRegistros.alertas.length > 0)">
            <b-alert variant="danger" show>Error al registrar en base de datos</b-alert>
          </div>

          <div class="mt-2" v-if=" insertRegistros.alertas != null && insertRegistros.alertas.length > 0">
            <b-alert variant="danger" show>Se encontraron alertas</b-alert>
          </div>

        </b-col>
        <b-col class="text-center" v-else>
          <br><br><br><br>
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
          <br><br><br><br>
        </b-col>

        <template #modal-footer="{ cancel }">
          <b-button variant="warning" @click="limpiarErrores()" v-if="insertRegistros.estado != null && !insertRegistros.estado && !cargandoRegistrosTotales">
            Limpiar errores
          </b-button>
          <b-button variant="success" @click="autorizarFinal('SI')" v-if="!cargandoRegistrosTotales">
            Autorizar
          </b-button>
          <b-button variant="danger" @click="autorizarFinal('NO')" v-if="!cargandoRegistrosTotales">
            Denegar autorización
          </b-button>
          <b-button variant="info" @click="cancel()" v-if="!cargandoRegistrosTotales">
            Cancelar
          </b-button>
        </template>

      </b-modal>

      <!-- Modal desautorizar -->
      <b-modal v-model="modalDesautoriza" size="lg" no-close-on-backdrop>

        <b-col v-if="!cargandoRegistrosTotales">

          <p class="my-4">
            Se aprobará la desautorización para {{seleccionados.length }} registros seleccionados.
            Desea continuar con el proceso de desautorización ?
          </p>

          <div class="mt-4" v-if=" insertRegistros.estado != null && !insertRegistros.estado">
            <!-- <b-alert class="mb-2" variant="danger" show>Error de carga</b-alert> -->
            <p>
              Se encontraron los siguientes errores
            </p>
          </div>

          <div class="mt-2" v-if=" insertRegistros.estado != null && !insertRegistros.estado && !( insertRegistros.alertas != null && insertRegistros.alertas.length > 0)">
            <b-alert variant="danger" show>Error al registrar en base de datos</b-alert>
          </div>

          <div class="mt-2" v-if=" insertRegistros.alertas != null && insertRegistros.alertas.length > 0">
            <b-alert variant="danger" show>Se encontraron alertas</b-alert>
          </div>

        </b-col>
        <b-col class="text-center" v-else>
          <br><br><br><br>
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
          <br><br><br><br>
        </b-col>

        <template #modal-footer="{ cancel }">
          <b-button variant="warning" @click="limpiarErrores()" v-if="insertRegistros.estado != null && !insertRegistros.estado && !cargandoRegistrosTotales">
            Limpiar errores
          </b-button>
          <b-button variant="danger" @click="autorizarFinal('SI_DES')" v-if="!cargandoRegistrosTotales">
            Desautorizar
          </b-button>
          <b-button variant="warning" @click="autorizarFinal('NO')" v-if="!cargandoRegistrosTotales">
            Negar solicitud
          </b-button>
          <b-button variant="info" @click="cancel()" v-if="!cargandoRegistrosTotales">
            Cancelar
          </b-button>
        </template>

      </b-modal>

      <b-tabs content-class="p-3" v-model="tabActual">

        <!-- Listar SOlicitudes -->
        <b-tab title="Solicitudes de autorización" v-if="$auth.can('validar_autorizaciones_estudiante') || $auth.can('validar_autorizaciones_profesor') || $auth.can('validar_autorizaciones_empleado') || $auth.can('validar_autorizaciones_visitante')">

          <b-row class="mt-3 mb-3">
            <b-col>
              <b-button class="mr-5" :variant="obtenerClase('TODOS')" @click="cambiarSeleccion('TODOS')">
                Todos
              </b-button>

              <b-button class="mr-3" :variant="obtenerClase('ESTUDIANTE')" @click="cambiarSeleccion('ESTUDIANTE')" v-if="$auth.can('validar_autorizaciones_estudiante')">
                Estudiantes
              </b-button>

              <b-button class="mr-3" :variant="obtenerClase('DOCENTE')" @click="cambiarSeleccion('DOCENTE')" v-if="$auth.can('validar_autorizaciones_profesor')">
                Profesores
              </b-button>

              <b-button class="mr-3" :variant="obtenerClase('EMPLEADO')" @click="cambiarSeleccion('EMPLEADO')" v-if="$auth.can('validar_autorizaciones_empleado')">
                Empleados
              </b-button>

              <b-button class="mr-3" :variant="obtenerClase('VISITANTE')" @click="cambiarSeleccion('VISITANTE')" v-if="$auth.can('validar_autorizaciones_visitante')">
                Visitantes
              </b-button>

            </b-col>

          </b-row>

          <!-- Segunda barra -->
          <b-row>
            <b-col md="8">
              <b-form-group label="Fecha:" label-for="input-filtro-fecha-desde-au">
                <b-input-group>
                  <b-input id="input-filtro-fecha-desde-au" placeholder="Desde" v-model="desdeBusqueda"></b-input>
                  <b-datepicker v-model="desdeBusqueda" button-only show-decade-nav></b-datepicker>
                  <b-input class="ml-4" placeholder="Hasta" v-model="hastaBusqueda"></b-input>
                  <b-datepicker v-model="hastaBusqueda" show-decade-nav button-only></b-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group label="Codigo:" label-for="input-codigo-au">
                <b-form-input id="input-codigo-au" type="text" v-model="codigoBusqueda"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="NRC:" label-for="input-periodo-au">
                <div class="input-group">
                  <b-form-input id="input-periodo-au" placeholder="Periodo" type="text" v-model="periodoBusqueda" :state="checkNrc"></b-form-input>
                  <b-form-input id="input-nrc-au" placeholder="NRC" type="text" v-model="nrcBusqueda" :state="checkNrc"></b-form-input>
                </div>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Solicitante:" label-for="input-solicitante-au">
                <b-form-input id="input-solicitante-au" type="text" v-model="solicitanteBusqueda"></b-form-input>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargando">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarRegistros('AUTORIZA')">
                Buscar solicitudes
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('AUTORIZA')" v-if="registros.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('AUTORIZA')" v-if="registros.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="success" @click="solicitarAutorizacion('AUTORIZA')" v-if="registros.length > 0">
                Autorizar o Negar Solicitud
              </b-button>

            </b-col>

          </b-row>

          <div v-if="!cargando">

            <div v-if="registros.length > 0">
              <b-table responsive striped hover :items="registros" :fields="camposAutorizaciones" caption-top>
                <template #table-caption>{{registros.length + ' registros'}}</template>
                <template #cell(SELECCION) class="d-flex justify-content-center">
                  <b-form-checkbox size="lg" name="AUTORIZA"></b-form-checkbox>
                </template>
                <template #cell(ALERTAS)="row" class="d-flex justify-content-center">
                  <div v-if="row.item.ALERTAS.length >= 1" class="text-center">
                    <b-badge v-if="row.item.ALERTAS.length > 0" v-b-modal="row.item.id" size="sm" variant="warning">Con alertas</b-badge>
                    <b-badge v-else variant="primary">Sin Alertas</b-badge>
                    <b-modal v-bind:id="row.item.id">
                      <div>
                        Se encontraron las siguientes alertas
                      </div>
                      <br>
                      <div v-for="alerta in row.item.ALERTAS" :key="alerta">
                        <b>{{ "- "+ alerta }}</b>
                      </div>

                      <template #modal-footer="{ cancel }">
                        <b-button variant="info" @click="cancel()">
                          Volver
                        </b-button>
                      </template>

                    </b-modal>
                  </div>
                  <b-badge v-else variant="primary">Sin Alertas</b-badge>
                  <b-badge v-if="row.item.ENCUESTA === 'No'" variant="warning">Sin encuesta</b-badge>
                </template>
                <template #cell(dia)="row">
                  <div>{{ dias[row.item.dia-1]}}</div>
                </template>

                <template #cell(fecha_inicio)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_inicio ) }}</div>
                </template>
                <template #cell(fecha_fin)="row">
                  <div>{{ eliminarHoraFecha( row.item.fecha_fin ) }}</div>
                </template>

              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron solicitudes</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>

        </b-tab>

        <!-- Listar solicitudes de desautorizacion -->
        <b-tab title="Solicitudes de desautorización" v-if="$auth.can('validar_autorizaciones')">

          <b-row class="mt-3 mb-3">
            <b-col>
              <b-button class="mr-5" v-bind:variant="obtenerClase('TODOS')" @click="cambiarSeleccion('TODOS')">
                Todos
              </b-button>

              <b-button class="mr-3" v-bind:variant="obtenerClase('ESTUDIANTE')" @click="cambiarSeleccion('ESTUDIANTE')">
                Estudiantes
              </b-button>

              <b-button class="mr-3" v-bind:variant="obtenerClase('DOCENTE')" @click="cambiarSeleccion('DOCENTE')">
                Profesores
              </b-button>

              <b-button class="mr-3" v-bind:variant="obtenerClase('EMPLEADO')" @click="cambiarSeleccion('EMPLEADO')">
                Empleados
              </b-button>

              <b-button class="mr-3" v-bind:variant="obtenerClase('VISITANTE')" @click="cambiarSeleccion('VISITANTE')">
                Visitantes
              </b-button>

            </b-col>
          </b-row>

          <!-- Segunda barra -->
          <b-row>
            <b-col md="8">
              <b-form-group label="Fecha:" label-for="input-filtro-fecha-desde-des">
                <b-input-group>
                  <b-input id="input-filtro-fecha-desde-des" placeholder="Desde" v-model="desdeBusqueda"></b-input>
                  <b-datepicker v-model="desdeBusqueda" button-only show-decade-nav></b-datepicker>
                  <b-input class="ml-4" placeholder="Hasta" v-model="hastaBusqueda"></b-input>
                  <b-datepicker v-model="hastaBusqueda" show-decade-nav button-only></b-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group label="Codigo:" label-for="input-codigo-des">
                <b-form-input id="input-codigo-des" type="text" v-model="codigoBusqueda"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="NRC:" label-for="input-periodo-des">
                <div class="input-group">
                  <b-form-input id="input-periodo-des" placeholder="Periodo" type="text" v-model="periodoBusqueda" :state="checkNrc"></b-form-input>
                  <b-form-input id="input-nrc-des" placeholder="NRC" type="text" v-model="nrcBusqueda" :state="checkNrc"></b-form-input>
                </div>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Solicitante:" label-for="input-filtro-nombre">
                <b-form-input id="input-solicitante-des" type="text" v-model="solicitanteBusqueda"></b-form-input>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row class="mt-2 mb-4" v-if="!cargando">

            <b-col>
              <b-button class="mr-2" md="12" variant="primary" @click="cargarRegistros('DESAUTORIZA')">
                Buscar solicitudes
              </b-button>

              <b-button class="mr-2" variant="info" @click="checkAll('DESAUTORIZA')" v-if="registros.length > 0">
                Seleccionar todo
              </b-button>

              <b-button class="mr-2" variant="info" @click="uncheckAll('DESAUTORIZA')" v-if="registros.length > 0">
                Deseleccionar todo
              </b-button>

              <b-button class="mr-2" variant="danger" @click="solicitarAutorizacion('DESAUTORIZA')" v-if="registros.length > 0">
                Desautorizar
              </b-button>

            </b-col>

          </b-row>

          <div v-if="!cargando">

            <div v-if="registros.length > 0">
              <b-table responsive striped hover :items="registros" :fields="camposAutorizacionesSinAlerta" caption-top>
                <template #table-caption>{{registros.length + ' registros'}}</template>
                <template #cell(SELECCION) class="d-flex justify-content-center">
                  <b-form-checkbox size="lg" name="DESAUTORIZA"></b-form-checkbox>
                </template>
                <template #cell(ALERTAS) class="d-flex justify-content-center">
                </template>
                <template #cell(dia)="row">
                  <div>{{ dias[row.item.dia-1]}}</div>
                </template>
              </b-table>
            </div>

            <div v-else>
              <b-alert show>No se encontraron solicitudes</b-alert>
            </div>

          </div>

          <div class="text-center" v-else>
            <br><br><br><br>
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            <br><br><br><br>
          </div>

        </b-tab>

        <!-- Tab Tabla autorizaciones pen espera de revision -->
        <!-- <b-tab title="Historial de solicitudes" v-if="$auth.can('validar_autorizaciones')">
          <b-table responsive striped hover :items="registros" :fields="camposAutorizaciones">
          </b-table>
          <b-pagination v-model="page" :total-rows="count" :per-page="limit" aria-controls="my-table" align="center"></b-pagination>
        </b-tab> -->

      </b-tabs>

    </div>

  </section>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator'
import { DateTimeFormatter, LocalDate } from '@js-joda/core'
import axios from 'axios'
import { url } from '../../../services/url_service'

@Component
export default class AutorizacionesEspera extends Vue {
  public dias: Array<any> = [
    'LUNES',
    'MARTES',
    'MIERCOLES',
    'JUEVES',
    'VIERNES',
    'SABADO',
    'DOMINGO',
  ]

  get hoy(): string {
    return LocalDate.now().format(DateTimeFormatter.ISO_LOCAL_DATE)
  }

  public page: number = 1
  public limit: number = 10
  public count: number = 0
  public filtros: any = {}
  public orden: any = {
    columna: 'fecha_inicio',
    direccion: 'ASC',
  }

  public pageErrores: number = 1
  public limitErrores: number = 10
  public countErrores: number = 0
  public errores: Array<any> = []

  public tabActual: number = 0

  // Iniciales
  public botonActivado: boolean = false
  public showOverlay: boolean = false
  public modalAutoriza: boolean = false
  public modalDesautoriza: boolean = false

  public seleccionados: Array<any> = []

  public desdeBusqueda: string = ""
  public hastaBusqueda: string = ""
  public codigoBusqueda: string = ""
  public periodoBusqueda: string = ""
  public nrcBusqueda: string = ""
  public solicitanteBusqueda: string = ""

  public seleccionTipo: string = ""

  public registros: Array<any> = []
  public cargando = false;
  public cargandoRegistrosTotales = false;

  public datosGenerador: any = {}

  public insertRegistros: any = {
    estado: null,
    cruces: null,
    alertas: null,
    limite_aforo: null,
  }


  // Esta pagina
  public seleccion = "TODOS"

  public camposAutorizaciones: Array<any> = [
    {
      key: 'SELECCION',
      label: 'Selección',
    },
    {
      key: 'ALERTAS',
      label: 'Alertas',
    },
    {
      key: 'id',
      label: 'Id',
    },
    {
      key: 'codigo',
      label: 'Código',
    },
    {
      key: 'nombre',
      label: 'Nombre',
    },
    {
      key: 'materia',
      label: 'Materia',
    },
    {
      key: 'periodo',
      label: 'Periodo',
    },
    {
      key: 'nrc',
      label: 'Nrc',
    },
    {
      key: 'asignatura',
      label: 'Asignatura/Motivo',
    },
    {
      key: 'ubicacion',
      label: 'Ubicación',
    },
    {
      key: 'fecha_inicio',
      label: 'Fecha de inicio',
    },
    {
      key: 'fecha_fin',
      label: 'Fecha Final',
    },
    {
      key: 'dia',
      label: 'Dia',
    },
    {
      key: 'hora_entrada',
      label: 'Hora de entrada',
    },
    {
      key: 'hora_salida',
      label: 'Hora de salida',
    },
  ]


  public camposAutorizacionesSinAlerta: Array<any> = [
    {
      key: 'SELECCION',
      label: 'Selección',
    },
    {
      key: 'id',
      label: 'Id',
    },
    {
      key: 'codigo',
      label: 'Código',
    },
    {
      key: 'nombre',
      label: 'Nombre',
    },
    {
      key: 'materia',
      label: 'Materia',
    },
    {
      key: 'periodo',
      label: 'Periodo',
    },
    {
      key: 'nrc',
      label: 'Nrc',
    },
    {
      key: 'asignatura',
      label: 'Asignatura/Motivo',
    },
    {
      key: 'ubicacion',
      label: 'Ubicación',
    },
    {
      key: 'fecha_inicio',
      label: 'Fecha de inicio',
    },
    {
      key: 'fecha_fin',
      label: 'Fecha Final',
    },
    {
      key: 'dia',
      label: 'Dia',
    },
    {
      key: 'hora_entrada',
      label: 'Hora de entrada',
    },
    {
      key: 'hora_salida',
      label: 'Hora de salida',
    },
  ]

  public checkNrc: boolean = null

  @Watch('tabActual')
  public onTabChange(value, oldValue) {
    if (oldValue != value) {
      this.checkNrc = null

      this.registros = [];
      this.cambiarSeleccion("TODOS");
      this.nrcBusqueda = '';
      this.periodoBusqueda = '';
      this.codigoBusqueda = '';
    }
  }

  public checkAll(registroTipo) {
    var items = document.getElementsByName(registroTipo);
    for (var i = 0; i < items.length; i++) {
      if (items[i].type == 'checkbox') {
        if (items[i].disabled == false) {
          items[i].checked = true;
        }
      }
    }
  }

  public eliminarHoraFecha(fechaEntra) {
    var fechaFinalSinHora = fechaEntra.substring(0, fechaEntra.indexOf(' '));
    return fechaFinalSinHora;
  }


  public uncheckAll(registroTipo) {
    var items = document.getElementsByName(registroTipo);
    for (var i = 0; i < items.length; i++) {
      if (items[i].type == 'checkbox')
        items[i].checked = false;
    }
  }

  public async cargarRegistros(tipoSolicitud) {

    try {

      this.cargando = true;
      this.registros = [];

      //var autorizadorCompleto = this.$auth.can('validar_autorizaciones');
      var parametros: any = {};

      //parametros["admin"] = autorizadorCompleto
      parametros["codigoSolicitante"] = this.datosGenerador.CODIGO
      parametros["desde"] = this.desdeBusqueda.trim()
      parametros["hasta"] = this.hastaBusqueda.trim()
      parametros["codigo"] = this.codigoBusqueda.trim()
      parametros["solicitante"] = this.solicitanteBusqueda.trim()
      parametros["periodo"] = this.periodoBusqueda.trim()
      parametros["nrc"] = this.nrcBusqueda.trim()
      parametros["tipoSolicitud"] = tipoSolicitud

      if (!this.$auth.can('any') && this.$auth.can('validar_autorizaciones_especial')) {
        parametros["especiales"] = true;
      }

      this.checkNrc = null
      if ((parametros.periodo && !parametros.nrc) || (parametros.nrc && !parametros.periodo)) {
        this.checkNrc = false
        this.cargando = false
        return
      }

      if (this.seleccion == 'TODOS') {

        let response = await axios.get(url.create('/internal/solicitudes'), { params: parametros })
        this.registros = response.data

      } else {

        let response = await axios.get(url.create('/internal/solicitudes/' + this.seleccion), { params: parametros })
        this.registros = response.data

      }

      this.cargando = false;

    } catch (error) {
      this.cargando = false;
    }

  }


  // Funciones de los botones
  public async cambiarSeleccion(seleccion) {
    this.uncheckAll('AUTORIZA');
    this.uncheckAll('DESAUTORIZA');
    this.registros = [];
    this.seleccion = seleccion;
  }

  public obtenerClase(property) {
    if (this.seleccion == property) {
      return 'info';
    } else {
      return '';
    }
  }

  public generarAlertas(alertas) {

    var alerta = '';
    for (var i = 0; i < alertas.length; i++) {
      alerta = alerta + '\n- ' + alertas[i];
    }
    return alerta;

  }

  public limpiarErrores() {
    this.insertRegistros = {
      estado: null,
      cruces: null,
      alertas: null,
      limite_aforo: null,
    };
  }

  public async cargarAutorizador() {

    try {
      let responsePersonal = await axios.get(
        url.create('/internal/vistas/personal')
      );
      this.datosGenerador = await responsePersonal.data ?? {}

    } catch (error) {
      console.log("Error al traer el registro de la vista");
      this.datosGenerador = {}
    }

  }

  public solicitarAutorizacion(tipoAut) {

    this.limpiarErrores();

    var registros = [];
    this.seleccionados = [];

    registros = this.registros;

    var items = document.getElementsByName(tipoAut);
    for (var i = 0; i < items.length; i++) {
      if (items[i].type == 'checkbox') {
        if (items[i].checked == true) {

          if (tipoAut == "AUTORIZA") {
            this.modalAutoriza = true;
          } else if (tipoAut == "DESAUTORIZA") {
            this.modalDesautoriza = true;
          }

          this.limpiarErrores();
          this.seleccionados.push(registros[i])

        }
      }
    }

  }

  //public async validaSeleccion(seleccion) {
  //
  //  var items = document.getElementsByName(seleccion);
  //  for (var i = 0; i < items.length; i++) {
  //    if (items[i].type == 'checkbox') {
  //      if (items[i].checked == true) {
  //        if (this.registros[i].ALERTAS.length >= 1) {
  //
  //          this.$bvToast.toast(
  //            'No es posible autorizar si alguno de los registros cuenta con alertas',
  //            {
  //              title: 'Registros con alertas',
  //              variant: 'warning',
  //              autoHideDelay: 5000,
  //            }
  //          )
  //          return true;
  //
  //        }
  //      }
  //    }
  //
  //  }
  //
  //  return false;
  //
  //}

  public async autorizarFinal(tipoAut) {

    this.limpiarErrores();
    this.cargandoRegistrosTotales = true;

    //var autorizadorCompleto = this.$auth.can('validar_autorizaciones');
    //var arregloSeleccion = JSON.stringify(this.seleccionados);

    if (this.datosGenerador.CODIGO == null) {
      this.datosGenerador.CODIGO = "ADMIN"
    }

    let especiales = this.$auth.can('validar_autorizaciones_especiales');

    var response;

    if (tipoAut == "SI") {

      ///var tieneAlertas = await this.validaSeleccion('AUTORIZA');

      ///if (!tieneAlertas) {

      response = await axios.post(
        url.create('/internal/solicitudes/autorizar'),
        {
          "registros": this.seleccionados,
          //"admin": autorizadorCompleto,
          "datosGenerador": this.datosGenerador,
        }
      );

      ///} else {
      ///
      ///  this.modalAutoriza = false;
      ///  this.modalDesautoriza = false;
      ///
      ///  this.cargandoRegistrosTotales = false;
      ///
      ///  return;
      ///}

  } else if(tipoAut == "NO") {
  response = await axios.post(
    url.create('/internal/solicitudes/denegar'),
    {
      "registros": this.seleccionados,
      //"admin": autorizadorCompleto,
      "datosGenerador": this.datosGenerador,
    }
  );
} else if (tipoAut == "SI_DES") {
  response = await axios.post(
    url.create('/internal/autorizaciones/desautorizar'),
    {
      "registros": this.seleccionados,
      //"admin": autorizadorCompleto,
      "datosGenerador": this.datosGenerador,
    }
  );
}

this.insertRegistros = response.data;

if (this.insertRegistros.estado) {

  this.limpiarErrores();
  this.uncheckAll('AUTORIZA');
  this.uncheckAll('DESAUTORIZA');
  this.registros = [];
  this.seleccionados = [];

  this.modalAutoriza = false;
  this.modalDesautoriza = false;

  if (tipoAut == "SI") {
    this.$bvToast.toast(
      'Se han autorizado los registros correctamente',
      {
        title: 'Registros autorizados',
        variant: 'success',
        autoHideDelay: 5000,
      }
    )
  } else {
    this.$bvToast.toast(
      'Se ha denegado la autorización de los registros correctamente',
      {
        title: 'Registros denegados',
        variant: 'success',
        autoHideDelay: 5000,
      }
    )
  }

}

this.cargandoRegistrosTotales = false;

  }


// Funciones de vue
@Watch('page')
public pageChange(val) {
  // this.cargarRegistros()
  // this.cargarErrores()
}

created() {

  this.cargarAutorizador();
  // this.cargarRegistros()
  // this.cargarErrores()
}
}
</script>

<style>
.tab-content {
  background-color: #ffffff;
}
</style>